export default __webpack_public_path__ + "static/media/gallery_06.11e39261.jpg";